/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFillFileXml = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M22 2.5H2v19h20zM10.743 8.169 6.845 12.5l3.898 4.331-1.486 1.338L4.155 12.5l5.102-5.669zm2.514 0 1.486-1.338 5.102 5.669-5.102 5.669-1.486-1.338 3.897-4.331z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFillFileXml as FillFileXml };
